import { render, staticRenderFns } from "./admin-all-requests.vue?vue&type=template&id=6299ed70&lang=pug&"
import script from "./admin-all-requests.vue?vue&type=script&lang=js&"
export * from "./admin-all-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports